module.exports = __webpack_public_path__ + "static/headlinecasing-dont-3a9fd1fd955409893d2c5299a4abaa6f.png";